import { InjectionToken } from "@angular/core";
import { Customer } from "@shared/models";

export const CUSTOMER_LISTENER = new InjectionToken<ICustomerListener>('cwt-customer-listener');

export interface ICustomerListener {
    customerInitialized(customer?: Customer): void;
}